import Model from '@/shared/models/CommissionPeriod'

export default class CommissionPeriod extends Model {}
